
export const SourceErrorState = () => {
    return <span className="badge badge-danger">Chyba</span>
}